import { render, staticRenderFns } from "./NotificationItemContentsParts.vue?vue&type=template&id=e8c7829e&scoped=true"
import script from "./NotificationItemContentsParts.vue?vue&type=script&lang=ts"
export * from "./NotificationItemContentsParts.vue?vue&type=script&lang=ts"
import style0 from "./NotificationItemContentsParts.vue?vue&type=style&index=0&id=e8c7829e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c7829e",
  null
  
)

export default component.exports